module.exports = __webpack_public_path__ + "img/historia10.5555dee1.jpg";